import type { DayView, TimeModels } from '../../../app/time/hourModels'
import { fmtTemp, temp, type Units } from '../../../shared/units'
import type { WeatherReport } from '../../../shared/contract'
import { dailyTemperatures } from '../../data/temperatures'
import { finite, HOUR, validRange } from '../panorama/geometry'

/** A day beyond coverage (or in a gap) must never clamp onto an unrelated last hour. */
export function supportedDay(day: DayView, models: TimeModels | null): boolean {
  const hour = day.hourIndex == null ? null : models?.hours[day.hourIndex]
  if (!hour) return false
  return day.jumpTo == null ? hour.date === day.date : day.jumpTo >= hour.t && day.jumpTo < hour.t + HOUR && hour.date === day.date
}

export function dayRanges(days: readonly DayView[], units: Units, report: WeatherReport | undefined) {
  const bounds = (day: DayView, side: 'low' | 'high') => {
    const r = day.day[`${side}_range`]
    return validRange(r) ? { low: temp(r.low, units.temp)!, high: temp(r.high, units.temp)! } : null
  }
  const temperatures = report ? dailyTemperatures(report) : null
  const rows = days.slice(0, 10).map((day) => {
    const range = temperatures?.get(day.date)
    return { day: range ? { ...day, low: fmtTemp(range.low, units.temp), high: fmtTemp(range.high, units.temp), lowValue: temp(range.low, units.temp), highValue: temp(range.high, units.temp) } : day, low: bounds(day, 'low'), high: bounds(day, 'high') }
  })
  const values = rows.flatMap((r) => [r.day.lowValue, r.day.highValue, r.low?.low, r.low?.high, r.high?.low, r.high?.high]).filter(finite)
  const min = values.length ? Math.min(...values) : 0, max = values.length ? Math.max(...values) : 1
  const position = (value: number) => 2 + (value - min) / Math.max(1, max - min) * 96
  const interval = (low: number, high: number) => ({ left: `${position(low)}%`, width: `${Math.max(.5, position(high) - position(low))}%` })
  return { rows, interval, hasBounds: rows.some((r) => r.low || r.high) }
}
